<template>
  <div class="dashboard-widget-settings">

    <el-form
      label-position="left"
      label-width="200px"
      style="width: 500px"
      size="mini"
    >
      <el-form-item label="Подпись оси X">
        <el-input v-model="localValue.xAxisTitle"></el-input>
      </el-form-item>
      <el-form-item label="Подпись оси Y">
        <el-input v-model="localValue.yAxisTitle"></el-input>
      </el-form-item>
      <el-form-item label="Показывать легенду">
        <el-switch v-model="localValue.legend"></el-switch>
      </el-form-item>
      <el-form-item label="Показывать значения X">
        <el-switch v-model="localValue.labelsX"></el-switch>
      </el-form-item>
      <el-form-item label="Показывать значения Y">
        <el-switch v-model="localValue.labelsY"></el-switch>
      </el-form-item>
      <el-form-item label="Подсказки при наведении">
        <el-switch v-model="localValue.tooltips"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Builder from "@/components/report/builder/Builder.vue";
import VQBForm from "@/components/report/builder/VQBForm.vue";

export default {
  name: 'VQBCellWidgetSettings',
  components: {VQBForm, Builder},
  props: {
    value: { type: Object, required: true },
  },
  computed: {
    localValue: {
      get() {return this.value},
      set(value) {this.$emit('input', value)}
    }
  },
  data(){
    return {}
  },
  methods: {}
}
</script>